import { Center } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentSms } from '@fortawesome/pro-regular-svg-icons';

const MfaSmsIcon = () => (
  <>
    <Center
      width={'2em'}
      height={'2em'}
      borderRadius={'full'}
      color={'white'}
      bgColor={'green.300'}
      _dark={{ bgColor: 'green.600' }}
    >
      <FontAwesomeIcon icon={faCommentSms} fixedWidth />
    </Center>
  </>
);

export default MfaSmsIcon;
